function getReference(selector, datasetBxfId, root = document, shadowRoot = false) {
    const findDataSetElement = (elm) => elm.dataset &&
        (elm.dataset.awId === datasetBxfId ||
            elm.dataset.bxfId === datasetBxfId);
    if (shadowRoot && root.shadowRoot) {
        return Array.from(root.shadowRoot.querySelectorAll(selector)).find(findDataSetElement);
    }
    return Array.from(root.querySelectorAll(selector)).find(findDataSetElement);
}

export { getReference as g };
